var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SfButton',{staticClass:"sf-button--pure microcart-icon",on:{"click":_vm.openMicrocart}},[_c('SfIcon',{attrs:{"icon":"empty_cart","has-badge":!!_vm.numberOfItems,"badge-label":_vm.numberOfItems + ''}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }